export default "__VITE_ASSET__BUSCVSU5__"